// src/assets/images/supportIcons.tsx
import React from 'react';

export const SupportIcons = {
    support: () => (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
            <path d="M8 10h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M8 14h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    ),

    faq: () => (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
            <circle cx="12" cy="10" r="1" fill="currentColor"/>
            <circle cx="16" cy="10" r="1" fill="currentColor"/>
            <circle cx="8" cy="10" r="1" fill="currentColor"/>
        </svg>
    ),

    device: () => (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7" y="6" width="10" height="14" rx="1.5" stroke="currentColor" strokeWidth="1.6" fill="none"/>
            <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" strokeWidth="1.6" fill="none"/>
            <circle cx="12" cy="11" r="1" fill="currentColor"/>
            <circle cx="12" cy="15" r="1" fill="currentColor"/>
        </svg>
    ),

    chat: () => (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
            <path d="M8 10h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M8 14h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    ),

    chevronRight: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
};